var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M209.3,122.6V200h-44.9v-72.2c0-18.1-6.5-30.5-22.7-30.5c-12.4,0-19.8,8.3-23,16.4c-1.2,2.9-1.5,6.9-1.5,10.9V200H72.3\r\n\t\tc0,0,0.6-122.3,0-134.9h44.9v19.1c-0.1,0.1-0.2,0.3-0.3,0.4h0.3v-0.4c6-9.2,16.6-22.3,40.4-22.3C187.2,61.9,209.3,81.2,209.3,122.6\r\n\t\tL209.3,122.6z M25.4,0C10,0,0,10.1,0,23.3c0,13,9.8,23.3,24.8,23.3h0.3c15.6,0,25.4-10.4,25.4-23.3C50.2,10.1,40.7,0,25.4,0L25.4,0\r\n\t\tz M2.7,200h44.9V65.1H2.7V200z M2.7,200"})));
}

Linkedin.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"209.3px","height":"200px","viewBox":"0 0 209.3 200","style":{"enableBackground":"new 0 0 209.3 200"},"xmlSpace":"preserve"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
